import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!supabase) {
      navigate('/', { replace: true });
      return;
    }
    supabase.auth.getSession().then(({ data: { session }, error: err }) => {
      if (err) {
        setError(err.message);
        return;
      }
      if (session) {
        navigate('/', { replace: true });
      } else {
        supabase!.auth.exchangeCodeForSession(window.location.search).then(({ error: e2 }) => {
          if (e2) { setError(e2.message); return; }
          navigate('/', { replace: true });
        });
      }
    });
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white px-4">
        <div className="text-center max-w-sm">
          <p className="text-sm font-semibold text-red-600 mb-2">Sign-in failed</p>
          <p className="text-xs text-gray-500 mb-4">{error}</p>
          <button onClick={() => navigate('/')} className="text-sm text-blue-500 underline">
            Back to home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-3">
        <div className="h-6 w-6 rounded-full border-2 border-blue-500 border-t-transparent animate-spin" />
        <p className="text-sm text-gray-500">Signing you in…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
